
import { reactApi, reactElement } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { comparePrimitives, stringHash, equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, isNullOrWhiteSpace, concat, join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { Button, TextDropdownButton, TextButton } from "../../Components/Button.js";
import { append as append_1, exists as exists_1, reduce, toArray as toArray_1, sortByDescending, take, length, empty as empty_1, contains, tryFind, map, singleton as singleton_1, isEmpty, filter, sortBy, tryHead, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toArray as toArray_2, exists, empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { useTranslation } from "react-i18next";
import { ToolState__ToI18nString, ProblemReportState } from "../../Shared/Tool.js";
import { toLocalTime, toString, utcNow, date as date_1, compare } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { AreaAnchorMenu, selectAndScroll } from "../../Widgets/AnchorMenu.js";
import { map as map_1, defaultArg, toArray, unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import Calendar_Warning from "../../../public/assets/icons/Calendar_Warning.svg";
import { canSeeTelematics, usePermissions } from "../../UserPermissions.js";
import { isOperational, targets, targetLabel, targetIcon, stateText, StateDot, allows as allows_1, useDefinitions, resolve } from "../../InventoryStates/Display.js";
import { ofSetState } from "../../Shared/InventoryStateMapping.js";
import { Permissions_allowsObject, StorageAccess, Permissions_allowsBooking, Permissions_allowsReceiverType, Permission, Permissions_has, Permissions_allowsInStorage } from "../../Shared/Roles.js";
import { InventoryBaseState, InventoryKind, InventoryAction } from "../../Shared/InventoryStates.js";
import { ChangeStorageDialog } from "../Dialog/ChangeStorageDialog.js";
import { Msg } from "./Types.js";
import { ChangeReturnDateDialog } from "../Dialog/ChangeReturnDateDialog.js";
import { SetReleaseDateDialog } from "../Dialog/SetReleaseDateDialog.js";
import { RequestTargetId as RequestTargetId_1, ChangeBusinessUnitDialog } from "../../Widgets/ChangeBusinessUnitDialog.js";
import { TextValue } from "../../Components/Text.js";
import { RouterModule_encodeQueryString, RouterModule_encodeParts, RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Feature, isFeatureEnabled } from "../../FeatureFlip.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { QuickOverviewList } from "../../Widgets/QuickOverviewList.js";
import Following from "../../../public/assets/icons/Following.svg";
import Followers from "../../../public/assets/icons/Followers.svg";
import { OpenCreateReservationDialog } from "../Dialog/CreateReservationDialog.js";
import { SetCreateProblemReportDialog } from "../Dialog/CreateProblemReportDialog.js";
import { StartProcedureDialog } from "../../Widgets/Procedure/StartProcedureDialog.js";
import { ProcedureEntityReferenceDto } from "../../Shared/Procedure.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { OpenAssignDialog } from "../Dialog/AssignDialog.js";
import { OpenUnassignDialog } from "../Dialog/UnassignDialog.js";
import { ReturnSetNotificationDialog } from "../Dialog/ReturnSetNotificationDialog.js";
import { SelfServiceAssignSetDialog } from "../Dialog/SelfServiceAssignSetDialog.js";
import { SelfServiceReturnSetDialog } from "../Dialog/SelfServiceReturnSetDialog.js";
import { OpenAssignFromReceiverToReceiverDialog } from "../Dialog/ReceiverToReceiverAssignDialog.js";
import { OpenStateChangeDialog } from "../Dialog/StateChangeDialog.js";
import Calendar_Add from "../../../public/assets/icons/Calendar_Add.svg";
import { unwrapStorageId } from "../../Shared/Helper.js";
import Order_History from "../../../public/assets/icons/Order_History.svg";
import Shipment_Warning from "../../../public/assets/icons/Shipment_Warning.svg";
import { PropertyList } from "../../Widgets/PropertyListWidget.js";
import { CustomPropertiesPropertyList } from "../../Widgets/CustomPropertiesPropertyList.js";
import { purchaseDate, price } from "../Common.js";
import { PrintLabelOptions, PrintLabelDialogFor, printLabelControl } from "../../Labels/PrintLabelsDialog.js";
import { AssetIdentifierTable, QrCodeTable } from "../../Widgets/Tables/QrCodeTable.js";
import { ModalSheet } from "../../Components/ModalSheet.js";
import { DocumentTable } from "../../Widgets/Tables/DocumentTable.js";
import { HistoryAccessProvider, OpenChangelogButtonModalSheet } from "../../Widgets/Modals/ChangelogModal.js";
import { LabelId, StorageId as StorageId_1, NoticeId, SetId as SetId_2, DocumentId__get_unwrap } from "../../Shared/Shared.js";
import { OnTableRowClick$1, ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";
import { UploadType as UploadType_2 } from "../../Widgets/Dialogs/FileUploadDialog.js";
import { OpenEditReservationDialog } from "../Dialog/EditReservationDialog.js";
import { OpenDeleteReservationDialog } from "../Dialog/DeleteReservationDialog.js";
import { TableControl$1, Table } from "../../Widgets/Table/Table.js";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Recycle_Bin_1 from "../../../public/assets/icons/Recycle_Bin_1.svg";
import { OpenCreateReminderDialog } from "../Dialog/CreateReminderDialog.js";
import { OpenEditReminderDialog } from "../Dialog/EditReminderDialog.js";
import { OpenDeleteReminderDialog } from "../Dialog/DeleteReminderDialog.js";
import { OpenConfirmReminderDialog } from "../Dialog/ConfirmReminderDialog.js";
import { ColoredDot } from "../../Components/ColoredDot.js";
import { FileDialog_LinkedDocumentToolType, FileDialog_LinkedEntityId, Modal_OpenLinkedDocumentModalButtonModalSheet } from "../../Widgets/Modals/LinkedDocumentModal.js";
import Check from "../../../public/assets/icons/Check.svg";
import { DataTransfer_DetailSet__ReadableDisplayName, BusinessLogic_SetEvent__get_SignatureUrl, BusinessLogic_SetEvent__get_Comment, BusinessLogic_SetEvent__ToTranslationString, BusinessLogic_SetEvent__get_StateReference, BusinessLogic_SetEvent__get_Timestamp } from "../../Shared/Set.js";
import { Helper_displayHistoryComment } from "../../Shared/Changelog.js";
import { AssignmentProtocolDialog, AssignmentProtocolParams } from "../../Widgets/AssignmentProtocol.js";
import { ProblemReportStateIndicator } from "../../Widgets/ProblemReportState.js";
import { NotificationArea } from "../../Widgets/Notification/NotificationArea.js";
import { NotificationToolType as NotificationToolType_1 } from "../../Widgets/Notification/AcceptNotificationDialog.js";
import { MultipleImageWidget } from "../../Widgets/Image/ImageWidget.js";
import { ChatWidget, Message as Message_1 } from "../../Widgets/ChatWidget.js";
import { OpenNoticeDeleteDialog } from "../Dialog/DeleteNoticeDialog.js";
import { SetStocktakingHistorySection, canReadStocktakingHistory, setToolLastStocktakingCell, useSetStocktakingHistoryIf } from "../../Widgets/StocktakingHistory.js";
import { NewToolModalView } from "../../Tools/Tool/Form/View.js";
import { SelectToolModal } from "../Dialog/SelectToolModal.js";
import { ConfirmationDialog } from "../../Components/Dialog.js";
import { Label as Label_12 } from "../../Shared/Category.js";
import Shipment_Add from "../../../public/assets/icons/Shipment_Add.svg";
import { isAvailable } from "../../Telematics/Feature.js";
import { TrackerMapSection, isVisible } from "../../Widgets/TrackerMapSection.js";
import { useAssignedTrackersIf } from "../../Requests/Telematics.js";
import { TrackerEntityType } from "../../Shared/Telematics.js";
import { LabelInventoryKind } from "../../Shared/Label.js";
import { DeleteDialog } from "../Dialog/DeleteDialog.js";
import { DetailViewHeader } from "../../Widgets/DetailViewHeader.js";
import { Badge } from "../../Components/Badge.js";
import { getQueryParams } from "../../Common.js";
import { TableContainerWithTabs, TableContainer, SectionContainer } from "../../Widgets/Container.js";
import { TrackerIdentifiers } from "../../Widgets/Tables/TrackerIdentifiers.js";
import { coverImageUrlOption } from "../../Shared/Image.js";
import { Skeleton } from "../../Components/Skeleton.js";
import { ChangelogTable } from "../../Widgets/Tables/ChangelogTable.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewSet } from "./State.js";

export function Box(props) {
    let elems_2, elems_1;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-background", "py-3", "px-4", "flex", "flex-col", "rounded"])], (elems_2 = [reactElement("div", {
        className: join(" ", ["text-sm", "font-semibold"]),
        children: props.Title,
    }), reactElement("div", {
        className: join(" ", ["flex", "flex-col", "divide-y", "divide-[#e9edf3]", "gap-2", "my-4", "grow"]),
        children: reactApi.Children.toArray([props.ContentElement]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-4"])], (elems_1 = [createElement(TextButton, {
        ComponentState: "enabled",
        Label: props.AdditionalInformation,
        OnClick: props.OnClick,
        TestId: concat("tool-selectcard-", props.AdditionalInformation, ..."-edit-button"),
        Variant: "blueButton",
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function InformationBox(props) {
    let elems_2;
    const contextLength = (props.ContentText.length > 100) ? concat(props.ContentText.slice(undefined, 100 + 1), ..."[...]") : props.ContentText;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "rounded", "drop-shadow-lg", "p-4"])], (elems_2 = toList(delay(() => {
        let matchValue, iconElement, elems_1;
        return append((matchValue = props.Icon, (matchValue != null) ? ((iconElement = matchValue, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "justify-between"])], (elems_1 = [reactElement("div", {
            className: join(" ", ["text-sm"]),
            children: contextLength,
        }), reactElement("div", {
            className: join(" ", ["text-red", "h-5", "w-5"]),
            children: reactApi.Children.toArray([iconElement]),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : singleton(reactElement("div", {
            className: join(" ", ["text-sm"]),
            children: contextLength,
        }))), delay(() => {
            const matchValue_1 = props.Title;
            if (matchValue_1 == null) {
                return empty();
            }
            else {
                const title = matchValue_1;
                return singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mt-3"]),
                    children: title,
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
}

export function NotificationsBox(props) {
    let Title_2;
    const t = useTranslation()[0];
    const problemReport = tryHead(sortBy((pr_1) => pr_1.Timestamp, filter((pr) => equals(pr.State, new ProblemReportState(0, [])), props.ProblemReports), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    const content = (problemReport == null) ? createElement(InformationBox, {
        ContentText: t("general.no_content"),
    }) : createElement(InformationBox, {
        ContentText: problemReport.Message,
    });
    return Box((Title_2 = t("tool.current_problem_report"), {
        AdditionalInformation: t("tool.to_problem_reports"),
        ContentElement: content,
        OnClick: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "problem-report-section-id");
        },
        Title: Title_2,
    }));
}

export function AppointmentBox(props) {
    let Title_2;
    const t = useTranslation()[0];
    const today = date_1(utcNow());
    const firstAppointment = tryHead(sortBy((a_1) => a_1.Date, filter((a) => !a.IsConfirmed, props.Set.Planning.Reminders), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    let informationBox;
    if (firstAppointment == null) {
        informationBox = createElement(InformationBox, {
            ContentText: t("general.no_content"),
        });
    }
    else {
        const appointment = firstAppointment;
        informationBox = createElement(InformationBox, {
            ContentText: toString(appointment.Date, "dd.MM.yyyy"),
            Icon: unwrap((compare(date_1(appointment.Date), today) <= 0) ? Calendar_Warning() : undefined),
            Title: appointment.Title,
        });
    }
    return Box((Title_2 = t("general.next_appointment"), {
        AdditionalInformation: t("general.to_planning"),
        ContentElement: informationBox,
        OnClick: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "appointments-section-id");
        },
        Title: Title_2,
    }));
}

export function ReservationBox(props) {
    let Title_2;
    const t = useTranslation()[0];
    const now = date_1(utcNow());
    const nextReservation = tryHead(sortBy((r_1) => r_1.StartDate, filter((r) => (compare(r.StartDate, now) >= 0), props.Set.Planning.Reservations), {
        Compare: (x, y) => (compare(x, y) | 0),
    }));
    let informationBox;
    if (nextReservation == null) {
        informationBox = createElement(InformationBox, {
            ContentText: t("general.no_content"),
        });
    }
    else {
        const reservation = nextReservation;
        informationBox = createElement(InformationBox, {
            ContentText: concat(toString(reservation.StartDate, "dd.MM.yyyy"), " - ", ...toString(reservation.EndDate, "dd.MM.yyyy")),
            Title: reservation.ReceiverInformation.ReceiverName,
        });
    }
    return Box((Title_2 = t("tool.next_reservation"), {
        AdditionalInformation: t("general.to_planning"),
        ContentElement: informationBox,
        OnClick: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "reservations-section-id");
        },
        Title: Title_2,
    }));
}

export function SetShortDetails(props) {
    let elems_18;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const currentState = resolve(useDefinitions(), props.Set.StateKey, ofSetState(props.Set.State));
    const allowsInStorage = (permission) => Permissions_allowsInStorage(permissions, permission, props.UserData.UserId, props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds);
    const canChangeBusinessUnit = (Permissions_has(permissions, new Permission(9, [])) && isEmpty(props.CurrentUser.BusinessUnitIds)) && allows_1(new InventoryAction(5, []), currentState);
    const patternInput_1 = reactApi.useState(false);
    const setIsSwitchStorageDialogOpen = patternInput_1[1];
    const isSwitchStorageDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsChangeReturnDateDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsReleaseDateDialogOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsChangeBusinessUnitDialogOpen = patternInput_4[1];
    let storageLocation;
    const matchValue = props.Set.LocationInformation.LocationName;
    storageLocation = ((matchValue == null) ? "" : concat("(", matchValue, ...")"));
    return reactElement("div", createObj(singleton_1((elems_18 = toList(delay(() => append(singleton(createElement(ChangeStorageDialog, {
        IsOpen: isSwitchStorageDialogOpen,
        OnClose: () => {
            setIsSwitchStorageDialogOpen(false);
        },
        Set: props.Set,
        Storages: props.Storages,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
        UserData: props.UserData,
    })), delay(() => append(singleton(createElement(ChangeReturnDateDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsChangeReturnDateDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            setIsChangeReturnDateDialogOpen(false);
            props.Dispatch(new Msg(32, []));
        },
    })), delay(() => append(singleton(createElement(SetReleaseDateDialog, {
        IsOpen: patternInput_3[0],
        OnClose: () => {
            setIsReleaseDateDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            setIsReleaseDateDialogOpen(false);
            props.Dispatch(new Msg(32, []));
        },
    })), delay(() => append(singleton(createElement(ChangeBusinessUnitDialog, {
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsChangeBusinessUnitDialogOpen(false);
        },
        OnSuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
        RequestTargetId: new RequestTargetId_1(1, [props.Set.Id]),
        SelectedBusinessUnitId: unwrap(props.Set.BusinessUnitId),
        StorageId: props.Set.LocationInformation.StorageId,
        Storages: props.Storages,
    })), delay(() => {
        let elems_2, elems_1, elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_2 = [reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: t("general.state"),
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems = [createElement(StateDot, {
            Definition: currentState,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextValue, {
            FontWeight: "normal",
            TestId: "inventory-state-text",
            Text: stateText(t, currentState, props.Set.StateDate),
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_4, elems_3;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_4 = [reactElement("div", {
                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                children: t("tool.assgined_to"),
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "tool-assigned-to-test-id"], (elems_3 = toList(delay(() => {
                const matchValue_1 = props.Set.LocationInformation.AssignedReceiverId;
                if (matchValue_1 != null) {
                    const assignedReceiverId = matchValue_1;
                    let receiverType;
                    const matchValue_2 = props.Set.LocationInformation.ReceiverTypeName;
                    if (matchValue_2 != null) {
                        const receiverTypeName = matchValue_2;
                        receiverType = ((receiverTypeName.tag === 1) ? t("receivers.employee") : ((receiverTypeName.tag === 2) ? t("receivers.externalperson") : ((receiverTypeName.tag === 3) ? t("receivers.subcontractor") : ((receiverTypeName.tag === 4) ? t("receivers.room") : ((receiverTypeName.tag === 5) ? t("receivers.project") : ((receiverTypeName.tag === 6) ? t("receivers.constructionsite") : ((receiverTypeName.tag === 7) ? t("receivers.student") : ((receiverTypeName.tag === 8) ? t("receivers.school_class") : ((receiverTypeName.tag === 9) ? t("receivers.vehicles") : ((receiverTypeName.tag === 10) ? t("receivers.api_receiver") : t("receivers.user")))))))))));
                    }
                    else {
                        receiverType = "";
                    }
                    return exists((receiverType_1) => Permissions_allowsReceiverType(permissions, new Permission(41, []), receiverType_1), toArray(props.Set.LocationInformation.ReceiverTypeName)) ? singleton(createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: concat(props.Set.LocationInformation.AssignedReceiverName, " (", receiverType, ...")"),
                        OnClick: () => {
                            RouterModule_nav(singleton_1(concat("/receivers/", ...assignedReceiverId)), 1, 1);
                        },
                        TestId: "assigned-receiver-text-button-test-id",
                        Variant: "blueButton",
                    })) : singleton(createElement(TextValue, {
                        FontWeight: "normal",
                        TestId: "",
                        Text: concat(props.Set.LocationInformation.AssignedReceiverName, " (", receiverType, ...")"),
                    }));
                }
                else {
                    return singleton(createElement(TextValue, {
                        FontWeight: "normal",
                        TestId: "",
                        Text: t("tool.not_assigned"),
                    }));
                }
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                let matchValue_3, assignedReceiverId_1, elems_6, elems_5;
                return append(isFeatureEnabled(new Feature(16, [])) ? (props.CustomerConfiguration.IsReleaseDateEnabled ? ((matchValue_3 = props.Set.LocationInformation.AssignedReceiverId, (matchValue_3 != null) ? ((assignedReceiverId_1 = matchValue_3, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_6 = [reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                    children: t("general.release_date"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "tool-release-date-test-id"], (elems_5 = toList(delay(() => {
                    let releaseDateLabel;
                    const matchValue_4 = props.Set.LocationInformation.ReleaseDate;
                    releaseDateLabel = ((matchValue_4 != null) ? toString(toLocalTime(matchValue_4), "dd.MM.yyyy") : t("general.no_release_date_set"));
                    return Permissions_allowsBooking(permissions, new Permission(7, []), props.UserData.UserId, props.Set.LocationInformation.AssignedStorageUserIds, assignedReceiverId_1 === props.UserData.UserId) ? singleton(createElement(TextButton, {
                        ComponentState: "enabled",
                        Label: releaseDateLabel,
                        OnClick: () => {
                            setIsReleaseDateDialogOpen(true);
                        },
                        TestId: "release-date-receiver-text-button-test-id",
                        Variant: "blueButton",
                    })) : singleton(createElement(TextValue, {
                        FontWeight: "normal",
                        TestId: "release-date-receiver-text-test-id",
                        Text: releaseDateLabel,
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))))) : (empty()))) : empty()) : empty(), delay(() => {
                    let matchValue_5, assignedReceiver, elems_8, elems_7;
                    return append((matchValue_5 = props.Set.LocationInformation.AssignedReceiverId, (matchValue_5 != null) ? ((assignedReceiver = matchValue_5, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_8 = [reactElement("div", {
                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                        children: t("tool.planned_return_date"),
                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], ["data-test-id", "tool-planned-return-date-test-id"], (elems_7 = toList(delay(() => {
                        let plannedReturnDateLabel;
                        const matchValue_6 = props.Set.LocationInformation.PlannedReturnDate;
                        plannedReturnDateLabel = ((matchValue_6 != null) ? toString(toLocalTime(matchValue_6), "dd.MM.yyyy") : t("general.no_planned_return_date_set"));
                        return allowsInStorage(new Permission(2, [])) ? singleton(createElement(TextButton, {
                            ComponentState: "enabled",
                            Label: plannedReturnDateLabel,
                            OnClick: () => {
                                setIsChangeReturnDateDialogOpen(true);
                            },
                            TestId: "planned-return-date-receiver-text-button-test-id",
                            Variant: "blueButton",
                        })) : singleton(createElement(TextValue, {
                            FontWeight: "normal",
                            TestId: "planned-return-date-receiver-text-test-id",
                            Text: plannedReturnDateLabel,
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))))) : (empty())), delay(() => {
                        let elems_10, elems_9;
                        return append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_10 = [reactElement("div", {
                            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                            children: t("business_units.business_unit"),
                        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_9 = toList(delay(() => {
                            const matchValue_7 = props.Set.BusinessUnitName;
                            if (matchValue_7 == null) {
                                return canChangeBusinessUnit ? singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: t("business_units.no_business_unit_set"),
                                    OnClick: () => {
                                        setIsChangeBusinessUnitDialogOpen(true);
                                    },
                                    TestId: "change-business-unit-text-button-test-id",
                                    Variant: "blueButton",
                                })) : singleton(defaultOf());
                            }
                            else {
                                const businessUnitName = matchValue_7;
                                return canChangeBusinessUnit ? singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: businessUnitName,
                                    OnClick: () => {
                                        setIsChangeBusinessUnitDialogOpen(true);
                                    },
                                    TestId: "change-business-unit-text-button-test-id",
                                    Variant: "blueButton",
                                })) : singleton(createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "tool-details-business-unit",
                                    Text: businessUnitName,
                                }));
                            }
                        })), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty()) : empty(), delay(() => {
                            let elems_12;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_12 = toList(delay(() => append(singleton(reactElement("div", {
                                className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                children: t("general.storage"),
                            })), delay(() => {
                                let elems_11;
                                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_11 = [createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "",
                                    Text: concat(props.Set.LocationInformation.StorageName, " ", ...storageLocation),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => ((allowsInStorage(new Permission(5, [])) && allows_1(new InventoryAction(4, []), currentState)) ? singleton(createElement(TextButton, {
                                    ComponentState: "enabled",
                                    Label: t("tool.switch_storage"),
                                    OnClick: () => {
                                        setIsSwitchStorageDialogOpen(!isSwitchStorageDialogOpen);
                                    },
                                    TestId: "switch-storage-text-button-test-id",
                                    Variant: "blueButton",
                                })) : empty())));
                            })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                                let elems_14, elems_13;
                                return append(!isNullOrWhiteSpace(props.Set.LocationInformation.StorageSpace) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_14 = [reactElement("div", {
                                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                    children: t("tool.storage_space"),
                                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_13 = [createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "",
                                    Text: props.Set.LocationInformation.StorageSpace,
                                })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])])))) : empty(), delay(() => {
                                    let matchValue_8, lastSeen, elems_16, elems_15;
                                    return append((matchValue_8 = props.Set.LastSeen, (matchValue_8 == null) ? (empty()) : ((lastSeen = matchValue_8, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_16 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("general.last_seen"),
                                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_15 = [createElement(TextValue, {
                                        FontWeight: "normal",
                                        TestId: "",
                                        Text: `${toString(toLocalTime(lastSeen.ScannedAt), "dd.MM.yyyy HH:mm")} ${t("general.last_seen_by")} ${lastSeen.ScannedByUserName} (${(lastSeen.ScanMethod === "nfc_tag") ? t("general.nfc_tag") : t("general.qr_code")})`,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))))))), delay(() => {
                                        let elems_17, Label_3, Label_4, Label_5, Label_6, Label_7, Label_8;
                                        return isFeatureEnabled(new Feature(3, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_17 = [createElement(QuickOverviewList, {
                                            Currency: props.CustomerConfiguration.Currency,
                                            Elements: {
                                                CommercialData: unwrap(props.Set.MasterData.CommercialData),
                                                Custom: ofArray([(Label_3 = t("tool.manufacturer"), {
                                                    Group: t("general.master_data"),
                                                    Key: "tool-manufacturer-fav-field",
                                                    Label: Label_3,
                                                    Value: props.Set.MasterData.Manufacturer,
                                                }), (Label_4 = t("tool.model"), {
                                                    Group: t("general.master_data"),
                                                    Key: "tool-model-fav-field",
                                                    Label: Label_4,
                                                    Value: props.Set.MasterData.Model,
                                                }), (Label_5 = t("tool.serial_number"), {
                                                    Group: t("general.master_data"),
                                                    Key: "tool-serialnumber-fav-field",
                                                    Label: Label_5,
                                                    Value: props.Set.MasterData.SerialNumber,
                                                }), (Label_6 = t("tool.displayname"), {
                                                    Group: t("general.master_data"),
                                                    Key: "tool-displayname-fav-field",
                                                    Label: Label_6,
                                                    Value: props.Set.MasterData.Name,
                                                }), (Label_7 = t("tool.inventory_number"), {
                                                    Group: t("general.master_data"),
                                                    Key: "tool-inventorynumber-fav-field",
                                                    Label: Label_7,
                                                    Value: props.Set.MasterData.InventoryNumber,
                                                }), (Label_8 = t("general.comment"), {
                                                    Group: t("general.master_data"),
                                                    Key: "tool-comment-fav-field",
                                                    Label: Label_8,
                                                    Value: props.Set.MasterData.Comment,
                                                })]),
                                                CustomProperties: props.Set.MasterData.CustomProperties,
                                            },
                                            FormState: props.QuickOverviewDialog.FormState,
                                            IsDialogOpen: props.QuickOverviewDialog.IsOpen,
                                            OnSave: (updatedVisibleKeys) => {
                                                props.Dispatch(new Msg(0, [updatedVisibleKeys]));
                                            },
                                            SetDialogOpen: (_arg_14) => {
                                                props.Dispatch(new Msg(2, []));
                                            },
                                            UserData: props.UserData,
                                            VisibleKeys: props.UserConfiguration.QuickOverviewConfiguration.ToolViewVisibleFieldKeys,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))) : empty();
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })))))))))), ["children", reactApi.Children.toArray(Array.from(elems_18))]))));
}

function SetDetailsActions(props) {
    let elems_3;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const definitions = useDefinitions();
    const currentState = resolve(definitions, props.Set.StateKey, ofSetState(props.Set.State));
    const allows = (action) => allows_1(action, currentState);
    const canBook = (permission, hasStorageRuleAccess) => Permissions_allowsBooking(permissions, permission, props.UserData.UserId, props.Set.LocationInformation.AssignedStorageUserIds, hasStorageRuleAccess);
    const canAssign = canBook(new Permission(6, []), false);
    const canReturn = canBook(new Permission(7, []), false);
    const canChangeStatus = Permissions_allowsInStorage(permissions, new Permission(4, []), props.UserData.UserId, props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds);
    const patternInput_1 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_1[1];
    const isReservationDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsAssignDialogOpen = patternInput_2[1];
    const isAssignDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsUnassignDialogOpen = patternInput_3[1];
    const isUnassignDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const setIsProblemReportOpen = patternInput_4[1];
    const isCreateProblemReportOpen = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const setIsReturnNotificationDialogOpen = patternInput_5[1];
    const isReturnNotificationDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(false);
    const setIsSelfServiceAssignDialogOpen = patternInput_6[1];
    const isSelfServiceAssignDialogOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsSelfServiceReturnDialogOpen = patternInput_7[1];
    const isSelfServiceReturnDialogOpen = patternInput_7[0];
    const patternInput_8 = reactApi.useState(undefined);
    const setSelectedTarget = patternInput_8[1];
    const patternInput_9 = reactApi.useState(false);
    const setIsAssignFromReceiverToReceiverDialogOpen = patternInput_9[1];
    const isAssignFromReceiverToReceiverDialogOpen = patternInput_9[0];
    const patternInput_10 = reactApi.useState(false);
    const setIsStartProcedureDialogOpen = patternInput_10[1];
    const isStartProcedureDialogOpen = patternInput_10[0];
    const actionButtons = toList(delay(() => {
        let Label_2, Label;
        return (props.Set.LocationInformation.AssignedReceiverId == null) ? ((canAssign && allows(new InventoryAction(0, []))) ? singleton(createElement(TextButton, (Label_2 = t("general.assign"), {
            ComponentState: "enabled",
            Icon: Following(),
            Label: Label_2,
            OnClick: () => {
                setIsAssignDialogOpen(true);
            },
            TestId: "tool-tooldetail-assign-button",
            Variant: "default",
        }))) : empty()) : append((canReturn && allows(new InventoryAction(3, []))) ? singleton(createElement(TextButton, (Label = t("general.take_back"), {
            ComponentState: "enabled",
            Icon: Followers(),
            Label: Label,
            OnClick: () => {
                setIsUnassignDialogOpen(true);
            },
            TestId: "tool-tooldetail-unassign-button",
            Variant: "default",
        }))) : empty(), delay(() => {
            let Label_1;
            return (canAssign && allows(new InventoryAction(0, []))) ? singleton(createElement(TextButton, (Label_1 = t("general.assign"), {
                ComponentState: "enabled",
                Icon: Following(),
                Label: Label_1,
                OnClick: () => {
                    setIsAssignFromReceiverToReceiverDialogOpen(true);
                },
                TestId: "tool-tooldetail-assign-receiver-to-receiver-button",
                Variant: "default",
            }))) : empty();
        }));
    }));
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-7", "mb-16"])], (elems_3 = toList(delay(() => append(isReservationDialogOpen ? singleton(createElement(OpenCreateReservationDialog, {
        IsOpen: isReservationDialogOpen,
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "reservations-section-id");
            props.Dispatch(new Msg(32, []));
        },
        UserData: props.UserData,
    })) : empty(), delay(() => append(isCreateProblemReportOpen ? singleton(createElement(SetCreateProblemReportDialog, {
        IsOpen: isCreateProblemReportOpen,
        OnClose: () => {
            setIsProblemReportOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            selectAndScroll(props.SetCurrentSelectedLink, "problem-report-section-id");
            props.Dispatch(new Msg(31, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isStartProcedureDialogOpen ? singleton(createElement(StartProcedureDialog, {
        EntityReference: new ProcedureEntityReferenceDto(3, [props.Set.Id]),
        IsOpen: isStartProcedureDialogOpen,
        LabelIds: map((label) => parse(label.Id), props.Set.AssignedLabel),
        OnClose: () => {
            setIsStartProcedureDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
    })) : empty(), delay(() => append(isAssignDialogOpen ? singleton(createElement(OpenAssignDialog, {
        IsOpen: isAssignDialogOpen,
        OnClose: () => {
            setIsAssignDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
        UserData: props.UserData,
    })) : empty(), delay(() => append(isUnassignDialogOpen ? singleton(createElement(OpenUnassignDialog, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isUnassignDialogOpen,
        OnClose: () => {
            setIsUnassignDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
        UserData: props.UserData,
    })) : empty(), delay(() => append(isReturnNotificationDialogOpen ? singleton(createElement(ReturnSetNotificationDialog, {
        IsOpen: isReturnNotificationDialogOpen,
        OnClose: () => {
            setIsReturnNotificationDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
    })) : empty(), delay(() => append(isSelfServiceAssignDialogOpen ? singleton(createElement(SelfServiceAssignSetDialog, {
        IsOpen: isSelfServiceAssignDialogOpen,
        OnClose: () => {
            setIsSelfServiceAssignDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceReturnDialogOpen ? singleton(createElement(SelfServiceReturnSetDialog, {
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: isSelfServiceReturnDialogOpen,
        OnClose: () => {
            setIsSelfServiceReturnDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
    })) : empty(), delay(() => {
        let matchValue_1, assignedReceiver;
        return append((matchValue_1 = props.Set.LocationInformation.AssignedReceiverId, (matchValue_1 == null) ? (empty()) : ((assignedReceiver = matchValue_1, isAssignFromReceiverToReceiverDialogOpen ? singleton(createElement(OpenAssignFromReceiverToReceiverDialog, {
            IsOpen: isAssignFromReceiverToReceiverDialogOpen,
            OnClose: () => {
                setIsAssignFromReceiverToReceiverDialogOpen(false);
            },
            Set: props.Set,
            SuccessCallback: () => {
                props.Dispatch(new Msg(32, []));
            },
        })) : empty()))), delay(() => {
            let matchValue_2;
            return append((matchValue_2 = patternInput_8[0], (matchValue_2 == null) ? (empty()) : singleton(createElement(OpenStateChangeDialog, {
                IsOpen: true,
                OnClose: () => {
                    setSelectedTarget(undefined);
                },
                Set: props.Set,
                SuccessCallback: () => {
                    props.Dispatch(new Msg(32, []));
                },
                Target: matchValue_2,
            }))), delay(() => {
                let elems_2, elems, elems_1;
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "grow", "justify-between"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4"])], (elems = toList(delay(() => {
                    let Label_3;
                    return append((allows(new InventoryAction(1, [])) && Permissions_has(permissions, new Permission(11, []))) ? singleton(createElement(TextButton, (Label_3 = t("dialog.reservation.btn_title"), {
                        ComponentState: "enabled",
                        Icon: Calendar_Add(),
                        Label: Label_3,
                        OnClick: () => {
                            setIsReservationDialogOpen(true);
                        },
                        TestId: "tool-tooldetail-reservate-button",
                        Variant: "default",
                    }))) : empty(), delay(() => {
                        let Label_4, Label_5, Label_6;
                        if (canAssign ? true : canReturn) {
                            return actionButtons;
                        }
                        else {
                            const storage = tryFind((s) => (unwrapStorageId(s.Id) === props.Set.LocationInformation.StorageId), props.Storages);
                            let isSelfServiceUser;
                            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                                isSelfServiceUser = true;
                            }
                            else if (storage == null) {
                                isSelfServiceUser = false;
                            }
                            else {
                                const s_1 = storage;
                                isSelfServiceUser = (s_1.IsSelfService ? true : contains(props.UserData.UserId, s_1.AccessByUser, {
                                    Equals: (x, y) => (x === y),
                                    GetHashCode: (x) => (stringHash(x) | 0),
                                }));
                            }
                            const canSelfServiceAssign = canBook(new Permission(6, []), isSelfServiceUser);
                            const canSelfServiceReturn = canBook(new Permission(7, []), isSelfServiceUser && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification);
                            const canRequestReturn = canBook(new Permission(7, []), true);
                            const matchValue_3 = props.Set.LocationInformation.AssignedReceiverId;
                            let matchResult, receiverId_1;
                            if (matchValue_3 != null) {
                                if (matchValue_3 === props.UserData.UserId) {
                                    matchResult = 1;
                                    receiverId_1 = matchValue_3;
                                }
                                else {
                                    matchResult = 2;
                                }
                            }
                            else if (canSelfServiceAssign && allows(new InventoryAction(0, []))) {
                                matchResult = 0;
                            }
                            else {
                                matchResult = 2;
                            }
                            switch (matchResult) {
                                case 0:
                                    return singleton(createElement(TextButton, (Label_4 = t("general.self_service_assign"), {
                                        ComponentState: "enabled",
                                        Icon: Following(),
                                        Label: Label_4,
                                        OnClick: () => {
                                            setIsSelfServiceAssignDialogOpen(true);
                                        },
                                        TestId: "set-detail-self-service-assign-button",
                                        Variant: "default",
                                    })));
                                case 1:
                                    return (canSelfServiceReturn && allows(new InventoryAction(3, []))) ? singleton(createElement(TextButton, (Label_5 = t("general.self_service_return"), {
                                        ComponentState: "enabled",
                                        Icon: Followers(),
                                        Label: Label_5,
                                        OnClick: () => {
                                            setIsSelfServiceReturnDialogOpen(true);
                                        },
                                        TestId: "set-detail-self-service-return-button",
                                        Variant: "default",
                                    }))) : ((canRequestReturn && allows(new InventoryAction(2, []))) ? singleton(createElement(TextButton, (Label_6 = t("general.request_return"), {
                                        ComponentState: "enabled",
                                        Icon: Followers(),
                                        Label: Label_6,
                                        OnClick: () => {
                                            setIsReturnNotificationDialogOpen(true);
                                        },
                                        TestId: "set-detail-return-notification-button",
                                        Variant: "default",
                                    }))) : empty());
                                default: {
                                    return empty();
                                }
                            }
                        }
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "gap-4", "items-center"])], (elems_1 = toList(delay(() => {
                    let Label_7;
                    return append((props.HasManualHooks && allows(new InventoryAction(7, []))) ? singleton(createElement(TextButton, (Label_7 = t("procedure.manual_start.button"), {
                        ComponentState: "enabled",
                        Icon: Order_History(),
                        Label: Label_7,
                        OnClick: () => {
                            setIsStartProcedureDialogOpen(true);
                        },
                        TestId: "set-detail-start-procedure-button",
                        Variant: "default",
                    }))) : empty(), delay(() => {
                        let Label_9;
                        const statusElements = map((target_1) => {
                            const Icon_8 = targetIcon(target_1);
                            return {
                                DisplayName: targetLabel(t, target_1),
                                Icon: unwrap(Icon_8),
                                OnClick: () => {
                                    setSelectedTarget(target_1);
                                },
                            };
                        }, targets(props.AccountSettings, new InventoryKind(1, []), currentState, definitions));
                        return (canChangeStatus && !isEmpty(statusElements)) ? singleton(createElement(TextDropdownButton, {
                            Classes: empty_1(),
                            ComponentState: "enabled",
                            DisplayArrow: true,
                            DisplayDivider: false,
                            Elements: statusElements,
                            Label: t("general.change_status"),
                            TestId: "set-detail-change-status-dropdown",
                        })) : (((Permissions_has(permissions, new Permission(37, [])) && allows(new InventoryAction(6, []))) && !isEmpty(props.Set.AssignedTools)) ? singleton(createElement(TextButton, (Label_9 = t("dialog.problem_report.btn_title"), {
                            ComponentState: "enabled",
                            Icon: Shipment_Warning(),
                            Label: Label_9,
                            OnClick: () => {
                                setIsProblemReportOpen(true);
                            },
                            TestId: "tool-create-problem-report-button",
                            Variant: "default",
                        }))) : empty());
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
            }));
        }));
    })))))))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function MasterDataSection(props) {
    let elems_4, elems_3;
    const t = useTranslation()[0];
    return reactElement("div", createObj(singleton_1((elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-20", "h-30"])], (elems_3 = toList(delay(() => {
        let elems_1, Title, elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(PropertyList, (Title = t("general.master_data"), {
            Properties: ofArray([{
                Label: t("tool.manufacturer"),
                TestId: "master-data-manufacturer",
                Value: props.Set.MasterData.Manufacturer,
            }, {
                Label: t("tool.model"),
                TestId: "master-data-model",
                Value: props.Set.MasterData.Model,
            }, {
                Label: t("tool.serial_number"),
                TestId: "master-data-serial-number",
                Value: props.Set.MasterData.SerialNumber,
            }, {
                Label: t("tool.displayname"),
                TestId: "master-data-display-name",
                Value: props.Set.MasterData.Name,
            }, {
                Label: t("tool.inventory_number"),
                TestId: "master-data-inventory-number",
                Value: props.Set.MasterData.InventoryNumber,
            }, {
                Label: t("general.comment"),
                TestId: "master-data-comment",
                Value: props.Set.MasterData.Comment,
            }]),
            Title: unwrap(Title),
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems = [createElement(CustomPropertiesPropertyList, {
            Currency: props.Currency,
            CustomProperties: props.Set.MasterData.CustomProperties,
            Title: t("tool.custom_properties"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
            let elems_2, Title_2;
            const matchValue = props.Set.MasterData.CommercialData;
            if (matchValue == null) {
                return empty();
            }
            else {
                const commercialData = matchValue;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(PropertyList, (Title_2 = t("tool.commercial_data"), {
                    Properties: ofArray([{
                        Label: t("general.supplier"),
                        TestId: "commercial-data-supplier",
                        Value: commercialData.Supplier,
                    }, {
                        Label: t("general.supplier_article_number"),
                        TestId: "commercial-data-supplier-article-number",
                        Value: commercialData.SupplierArticleNumber,
                    }, {
                        Label: t("general.purchase_price"),
                        TestId: "commercial-data-purchase-price",
                        Value: price(commercialData.PurchasePrice, props.Currency),
                    }, {
                        Label: t("general.purchase_date"),
                        TestId: "commercial-data-purchase-date",
                        Value: purchaseDate(commercialData.PurchaseDate),
                    }, {
                        Label: t("general.gurantee_date"),
                        TestId: "commercial-data-guarantee-date",
                        Value: purchaseDate(commercialData.WarrantyDate),
                    }, {
                        Label: t("general.comment"),
                        TestId: "commercial-data-comment",
                        Value: commercialData.Comment,
                    }]),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))]))));
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsPrintLabelOpen = patternInput_2[1];
    const onPrintLabel = printLabelControl(props.PrintLabel, () => {
        setIsPrintLabelOpen(true);
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(PrintLabelDialogFor, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsPrintLabelOpen(false);
        },
        Options: props.PrintLabel,
    })), delay(() => append(singleton(createElement(QrCodeTable, {
        OnAssignQrCode: (arg) => {
            props.Dispatch(new Msg(4, [arg]));
        },
        OnDeleteQrCodes: (arg_1) => {
            props.Dispatch(new Msg(5, [arg_1]));
        },
        OnPrintLabel: unwrap(onPrintLabel),
        QrCodes: (length(props.QRCodeIds) > 5) ? take(5, props.QRCodeIds) : props.QRCodeIds,
        Storage: unwrap(props.Storage),
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(props.QRCodeIds) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_code"), {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTable, {
                OnAssignQrCode: (qrCode) => {
                    props.Dispatch(new Msg(4, [qrCode]));
                },
                OnDeleteQrCodes: (qrCode_1) => {
                    props.Dispatch(new Msg(5, [qrCode_1]));
                },
                OnPrintLabel: unwrap(onPrintLabel),
                QrCodes: props.QRCodeIds,
                Storage: unwrap(props.Storage),
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function AssetIdentifiersSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsPrintLabelOpen = patternInput_2[1];
    const onPrintLabel = printLabelControl(props.PrintLabel, () => {
        setIsPrintLabelOpen(true);
    });
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(PrintLabelDialogFor, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsPrintLabelOpen(false);
        },
        Options: props.PrintLabel,
    })), delay(() => append(singleton(createElement(AssetIdentifierTable, {
        AssetIdentifiers: (length(props.AssetIdentifiers) > 5) ? take(5, props.AssetIdentifiers) : props.AssetIdentifiers,
        OnAssignQrCode: (arg) => {
            props.Dispatch(new Msg(4, [arg]));
        },
        OnDeleteQrCodes: (arg_1) => {
            props.Dispatch(new Msg(5, [arg_1]));
        },
        OnPrintLabel: unwrap(onPrintLabel),
        Storage: unwrap(props.Storage),
        UserData: props.UserData,
    })), delay(() => {
        let elems, Title;
        return (length(props.AssetIdentifiers) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, (Title = t("general.qr_codes_and_nfc_tags"), {
            CloseButtonTestId: "",
            Content: createElement(AssetIdentifierTable, {
                AssetIdentifiers: props.AssetIdentifiers,
                OnAssignQrCode: (arg_2) => {
                    props.Dispatch(new Msg(4, [arg_2]));
                },
                OnDeleteQrCodes: (arg_3) => {
                    props.Dispatch(new Msg(5, [arg_3]));
                },
                OnPrintLabel: unwrap(onPrintLabel),
                Storage: unwrap(props.Storage),
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => {
        let Documents;
        return append(singleton(createElement(DocumentTable, (Documents = ((length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents), {
            AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                EntityId: DocumentId__get_unwrap(dto.Id),
            })])), "none", "button")),
            Documents: Documents,
            OnDownloadFile: (tupledArg) => {
                props.Dispatch(new Msg(20, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                props.Dispatch(new Msg(19, []));
            },
            UploadType: new UploadType_2(3, [props.SetId]),
            UserData: props.UserData,
        }))), delay(() => {
            let elems, Title;
            return (length(props.Documents) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, (Title = t("general.documents"), {
                CloseButtonTestId: "",
                Content: createElement(DocumentTable, {
                    AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto_1) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: DocumentId__get_unwrap(dto_1.Id),
                    })])), "none", "button")),
                    Documents: props.Documents,
                    OnDownloadFile: (tupledArg_1) => {
                        props.Dispatch(new Msg(20, [tupledArg_1[0], tupledArg_1[1]]));
                    },
                    UploadSuccessCallback: () => {
                        props.Dispatch(new Msg(19, []));
                    },
                    UploadType: new UploadType_2(3, [props.SetId]),
                    UserData: props.UserData,
                }),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: unwrap(Title),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ReservationSection(props) {
    const t = useTranslation()[0];
    const currentState = resolve(useDefinitions(), props.Set.StateKey, ofSetState(props.Set.State));
    const permissions = usePermissions();
    const now = date_1(utcNow());
    const storageAccess = new StorageAccess(props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds);
    const patternInput_1 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_1[1];
    const isReservationDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsModalOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReservation = patternInput_3[1];
    const selectedReservation = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReservation = patternInput_4[1];
    const selectedDeleteReservation = patternInput_4[0];
    const reservations = sortByDescending((r) => r.StartDate, props.Set.Planning.Reservations, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_2 = toList(delay(() => append(isReservationDialogOpen ? singleton(createElement(OpenCreateReservationDialog, {
        IsOpen: isReservationDialogOpen,
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
        UserData: props.UserData,
    })) : empty(), delay(() => {
        let matchValue;
        return append((matchValue = selectedReservation, (matchValue == null) ? (empty()) : singleton(createElement(OpenEditReservationDialog, {
            IsOpen: selectedReservation != null,
            OnClose: () => {
                setSelectedReservation(undefined);
            },
            Reservation: matchValue,
            SetId: new SetId_2(parse(props.Set.Id)),
            SuccessCallback: () => {
                props.Dispatch(new Msg(32, []));
            },
            UserData: props.UserData,
        }))), delay(() => {
            let matchValue_1, reservation_2;
            return append((matchValue_1 = selectedDeleteReservation, (matchValue_1 == null) ? (empty()) : ((reservation_2 = matchValue_1, singleton(createElement(OpenDeleteReservationDialog, {
                IsOpen: selectedDeleteReservation != null,
                OnClose: () => {
                    setSelectedDeleteReservation(undefined);
                },
                Reservation: unwrap(selectedDeleteReservation),
                Set: props.Set,
                SuccessCallback: () => {
                    props.Dispatch(new Msg(32, []));
                },
                UserData: props.UserData,
            }))))), delay(() => {
                let elems_1;
                const table = (rows) => {
                    let TableRows, Options;
                    return createElement(Table, (TableRows = toArray_1(rows), (Options = {
                        BorderStyle: "row",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultSortColumn: ["startDate", "asc"],
                        Fullscreen: false,
                        GlobalSearch: false,
                        RowSelection: "singleRow",
                        SaveTableConfiguration: false,
                    }, {
                        ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto) => (new CellContent(8, [dto.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_1) => (new CellContent(8, [dto_1.EndDate])), "dateRange", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_2) => (new CellContent(0, [dto_2.ReceiverInformation.ReceiverName])), "none", "text"), new ColumnDefinition$1("reservationName", "", t("general.name"), (dto_3) => (new CellContent(0, [dto_3.Name])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_4) => (new CellContent(0, [dto_4.Description])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.created_by"), (dto_5) => (new CellContent(0, [dto_5.SenderInformation.SenderName])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                            EntityId: dto_6.Id,
                        })])), "none", "button")],
                        Controls: toList(delay(() => append(allows_1(new InventoryAction(1, []), currentState) ? append(Permissions_has(permissions, new Permission(11, [])) ? singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                            setIsReservationDialogOpen(true);
                        }, false, false, "set-reservation-create-action")) : empty(), delay(() => (Permissions_has(permissions, new Permission(12, [])) ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                if (Permissions_allowsObject(permissions, new Permission(12, []), props.UserData.UserId, storageAccess, planning.ReceiverInformation.ReceiverId)) {
                                    setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "set-reservation-edit-action")) : empty()))) : empty(), delay(() => (Permissions_has(permissions, new Permission(13, [])) ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_2) => {
                            const selectedRow_1 = tryHead(rows_2);
                            if (selectedRow_1 == null) {
                            }
                            else {
                                const planning_1 = selectedRow_1;
                                if (Permissions_allowsObject(permissions, new Permission(13, []), props.UserData.UserId, storageAccess, planning_1.ReceiverInformation.ReceiverId)) {
                                    setSelectedDeleteReservation(planning_1);
                                }
                            }
                        }, true, false, "set-reservation-delete-action")) : empty()))))),
                        Options: Options,
                        TableKey: "not-defined-table",
                        TableRows: TableRows,
                    })));
                };
                return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                    let elems;
                    return (length(reservations) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                        ComponentState: "enabled",
                        Label: t("general.show_more_data"),
                        OnClick: () => {
                            setIsModalOpen(true);
                        },
                        TestId: "set-reservations-showmoredata-button",
                        Variant: "blueButton",
                    }), createElement(ModalSheet, {
                        CloseButtonTestId: "",
                        Content: table(reservations),
                        Controls: empty_1(),
                        IsModalOpen: patternInput_2[0],
                        OnClose: () => {
                            setIsModalOpen(false);
                        },
                        Title: t("navbar.reservation"),
                    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
            }));
        }));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

function AppointmentsSection(props) {
    const t = useTranslation()[0];
    const currentState = resolve(useDefinitions(), props.Set.StateKey, ofSetState(props.Set.State));
    const patternInput_1 = reactApi.useState(false);
    const setIsReminderDialogOpen = patternInput_1[1];
    const isReminderDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setSelectedReminderToConfirm = patternInput_2[1];
    const selectedReminderToConfirm = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReminder = patternInput_3[1];
    const selectedReminder = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReminder = patternInput_4[1];
    const selectedDeleteReminder = patternInput_4[0];
    const now = utcNow();
    const patternInput_5 = reactApi.useState(false);
    const setIsModalOpen = patternInput_5[1];
    const reminders = sortByDescending((r) => r.Date, props.Set.Planning.Reminders, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const xs_3 = toList(delay(() => append(isReminderDialogOpen ? singleton(createElement(OpenCreateReminderDialog, {
        IsOpen: isReminderDialogOpen,
        OnClose: () => {
            setIsReminderDialogOpen(false);
        },
        SetId: new SetId_2(parse(props.Set.Id)),
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
    })) : empty(), delay(() => append((selectedReminder != null) ? singleton(createElement(OpenEditReminderDialog, {
        IsOpen: selectedReminder != null,
        OnClose: () => {
            setSelectedReminder(undefined);
        },
        Reminder: unwrap(selectedReminder),
        SetId: new SetId_2(parse(props.Set.Id)),
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
        },
    })) : empty(), delay(() => append((selectedDeleteReminder != null) ? singleton(createElement(OpenDeleteReminderDialog, {
        IsOpen: selectedDeleteReminder != null,
        OnClose: () => {
            setSelectedDeleteReminder(undefined);
        },
        Reminder: unwrap(selectedDeleteReminder),
        SetId: new SetId_2(parse(props.Set.Id)),
        SuccessCallback: () => {
            props.Dispatch(new Msg(32, []));
            props.Dispatch(new Msg(19, []));
        },
    })) : empty(), delay(() => {
        let matchValue;
        return append((matchValue = selectedReminderToConfirm, (matchValue == null) ? (empty()) : singleton(createElement(OpenConfirmReminderDialog, {
            IsOpen: selectedReminderToConfirm != null,
            OnClose: () => {
                setSelectedReminderToConfirm(undefined);
            },
            Reminder: matchValue,
            SetId: new SetId_2(parse(props.Set.Id)),
            SuccessCallback: (isFileUploaded) => {
                props.Dispatch(new Msg(32, []));
                if (isFileUploaded) {
                    props.Dispatch(new Msg(19, []));
                }
            },
        }))), delay(() => {
            let elems_2;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray_1(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["date", "desc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(8, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(8, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => {
                        let elems;
                        return reminderDate.IsConfirmed ? (new CellContent(2, [createElement(ColoredDot, {
                            Color: "green",
                        })])) : ((compare(reminderDate.Date, now) > 0) ? (new CellContent(2, [createElement(ColoredDot, {
                            Color: "orange",
                        })])) : (new CellContent(2, [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])));
                    }, "none", "text"), new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Title])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_3) => (new CellContent(0, [dto_3.Description])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => (new CellContent(0, [dto_4.ConfirmationComment])), "none", "text"), new ColumnDefinition$1("hasDocumentLinked", "", t("document_reminder_relation.documents_link"), (dto_5) => (new CellContent(2, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                        Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), dto_5.DocumentIds, {
                            Equals: (x_1, y_1) => (x_1 === y_1),
                            GetHashCode: (x_1) => (stringHash(x_1) | 0),
                        }), props.Documents),
                        LinkedEntityId: new FileDialog_LinkedEntityId(0, [dto_5.Id]),
                        OnClose: () => {
                            props.Dispatch(new Msg(19, []));
                            props.Dispatch(new Msg(32, []));
                        },
                        UploadType: new FileDialog_LinkedDocumentToolType(3, [new SetId_2(parse(props.Set.Id))]),
                        UserData: props.UserData,
                    })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(2, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_6.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => append((equals(currentState.BaseState, new InventoryBaseState(0, [])) ? true : equals(currentState.BaseState, new InventoryBaseState(1, []))) ? (props.Set.AccessInformation.IsUserResponsible ? append(singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                        setIsReminderDialogOpen(true);
                    }, false, false, "tool-new-reminder-test-id")), delay(() => append(singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                        const selectedRow = tryHead(rows_1);
                        if (selectedRow == null) {
                        }
                        else {
                            setSelectedReminder(selectedRow);
                        }
                    }, true, false, "set-detail-edit-reminder")), delay(() => singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                        const selectedRow_1 = tryHead(rows_2);
                        if (selectedRow_1 != null) {
                            setSelectedReminderToConfirm(selectedRow_1);
                        }
                    }, false, false, "set-detail-mark-reminder-as-done")))))) : empty()) : empty(), delay(() => (props.Set.AccessInformation.IsUserResponsible ? singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_3) => {
                        const selectedRow_3 = tryHead(rows_3);
                        if (selectedRow_3 == null) {
                        }
                        else {
                            setSelectedDeleteReminder(selectedRow_3);
                        }
                    }, true, false, "set-detail-delete-reminder")) : empty()))))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_2 = toList(delay(() => append(singleton(table((length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                let elems_1;
                return (length(reminders) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems_1 = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "set-reminders-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reminders),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_5[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("general.appointments"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }));
    }))))))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function HistorySection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setAssignmentProtocolParams = patternInput_2[1];
    const table = (rows) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray_1(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (dto) => (new CellContent(9, [BusinessLogic_SetEvent__get_Timestamp(dto.Event)])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (dto_1) => (new CellContent(0, [defaultArg(map_1((_arg) => _arg.Name, BusinessLogic_SetEvent__get_StateReference(dto_1.Event)), t(BusinessLogic_SetEvent__ToTranslationString(dto_1.Event)))])), "select", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_2) => {
                const matchValue = dto_2.Event;
                switch (matchValue.tag) {
                    case 11:
                        return new CellContent(0, [Helper_displayHistoryComment(t(matchValue.fields[0].Event), BusinessLogic_SetEvent__get_Comment(dto_2.Event))]);
                    default:
                        return new CellContent(0, [t(BusinessLogic_SetEvent__get_Comment(dto_2.Event))]);
                }
            }, "none", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (dto_3) => (new CellContent(0, [defaultArg(dto_3.Receiver, "")])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (dto_4) => (new CellContent(0, [dto_4.Sender])), "none", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (dto_5) => (new CellContent(6, [defaultArg(BusinessLogic_SetEvent__get_SignatureUrl(dto_5.Event), "")])), "none", "image"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_6) => (new CellContent(0, [defaultArg(dto_6.Storage, "")])), "none", "text"), new ColumnDefinition$1("action", "", "", (dto_7) => {
                const matchValue_1 = dto_7.Event;
                switch (matchValue_1.tag) {
                    case 1: {
                        const event_1 = matchValue_1.fields[0];
                        return new CellContent(3, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType_1, ReceiverName_1, ImageUrl_1, EntityImageUrl_1;
                            setAssignmentProtocolParams((AssignmentType_1 = t(BusinessLogic_SetEvent__ToTranslationString(dto_7.Event)), (ReceiverName_1 = defaultArg(dto_7.Receiver, ""), (ImageUrl_1 = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), (EntityImageUrl_1 = (props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.EntityImage ? props.EntityImageUrl : undefined), new AssignmentProtocolParams(AssignmentType_1, props.SetName, props.InventoryNumber, dto_7.Sender, ReceiverName_1, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_3, code_1) => concat(list_3, ", ", ...code_1), props.QrCodeIds)) : undefined, dto_7.Storage, "", undefined, event_1.SignatureUrl, event_1.Timestamp, ImageUrl_1, EntityImageUrl_1, dto_7.SenderImageUrls, dto_7.ReceiverImageUrls))))));
                        }]);
                    }
                    case 2: {
                        const event_2 = matchValue_1.fields[0];
                        return new CellContent(3, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType_2, ReceiverName_2, ImageUrl_2, EntityImageUrl_2;
                            setAssignmentProtocolParams((AssignmentType_2 = t(BusinessLogic_SetEvent__ToTranslationString(dto_7.Event)), (ReceiverName_2 = defaultArg(dto_7.Receiver, ""), (ImageUrl_2 = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), (EntityImageUrl_2 = (props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.EntityImage ? props.EntityImageUrl : undefined), new AssignmentProtocolParams(AssignmentType_2, props.SetName, props.InventoryNumber, dto_7.Sender, ReceiverName_2, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_5, code_2) => concat(list_5, ", ", ...code_2), props.QrCodeIds)) : undefined, dto_7.Storage, event_2.Comment, undefined, event_2.SignatureUrl, event_2.Timestamp, ImageUrl_2, EntityImageUrl_2, dto_7.SenderImageUrls, dto_7.ReceiverImageUrls))))));
                        }]);
                    }
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    case 9:
                    case 10:
                    case 16:
                    case 17:
                    case 11:
                    case 12:
                    case 13:
                        return new CellContent(0, [""]);
                    case 14:
                        return new CellContent(3, [t("procedure.view_results"), () => {
                            RouterModule_nav(ofArray(["procedures", matchValue_1.fields[0].ProcedureId, "results"]), 1, 1);
                        }]);
                    case 15:
                        return new CellContent(3, [t("procedure.view_results"), () => {
                            RouterModule_nav(ofArray(["procedures", matchValue_1.fields[0].ProcedureId, "results"]), 1, 1);
                        }]);
                    default: {
                        const event = matchValue_1.fields[0];
                        return new CellContent(3, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType, ReceiverName, ImageUrl, EntityImageUrl;
                            setAssignmentProtocolParams((AssignmentType = t(BusinessLogic_SetEvent__ToTranslationString(dto_7.Event)), (ReceiverName = defaultArg(dto_7.Receiver, ""), (ImageUrl = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), (EntityImageUrl = (props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.EntityImage ? props.EntityImageUrl : undefined), new AssignmentProtocolParams(AssignmentType, props.SetName, props.InventoryNumber, dto_7.Sender, ReceiverName, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), props.QrCodeIds)) : undefined, dto_7.Storage, event.Comment, undefined, event.SignatureUrl, event.Timestamp, ImageUrl, EntityImageUrl, dto_7.SenderImageUrls, dto_7.ReceiverImageUrls))))));
                        }]);
                    }
                }
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["timestamp", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssignmentProtocolDialog, {
        AssignmentProtocolParams: unwrap(patternInput_2[0]),
        OnClose: () => {
            setAssignmentProtocolParams(undefined);
        },
    })), delay(() => append(singleton(table((length(props.HistoryRows) > 5) ? take(5, props.HistoryRows) : props.HistoryRows)), delay(() => {
        let elems;
        return (length(props.HistoryRows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(props.HistoryRows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: t("history.title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ProblemReportSection(props) {
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsProblemReportOpen = patternInput_2[1];
    const isCreateProblemReportOpen = patternInput_2[0];
    const currentState = resolve(useDefinitions(), props.Set.StateKey, ofSetState(props.Set.State));
    const canReportProblem = ((Permissions_has(permissions, new Permission(37, [])) && allows_1(new InventoryAction(6, []), currentState)) && isOperational(currentState)) && !isEmpty(props.Set.AssignedTools);
    const table = (rows) => {
        let TableRows, ColumnDefinitions, Options;
        return createElement(Table, (TableRows = toArray_1(sortByDescending((r) => equals(r.State, new ProblemReportState(0, [])), rows, {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        })), (ColumnDefinitions = [new ColumnDefinition$1("timestamp", "", t("tool.problem_report_registered_on"), (dto) => (new CellContent(9, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("sender", "", t("tool.problem_report_reported_by"), (dto_1) => (new CellContent(0, [dto_1.SenderName])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.message"), (dto_2) => (new CellContent(0, [dto_2.Message])), "none", "text"), new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.DisplayName])), "text", "text"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_1) => (new CellContent(0, [row_1.InventoryNumber])), "text", "text"), new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_2) => (new CellContent(0, [row_2.Manufacturer])), "text", "text"), new ColumnDefinition$1("model", "", t("tool.model"), (row_3) => (new CellContent(0, [row_3.Model])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_4) => (new CellContent(0, [row_4.SerialNumber])), "text", "text"), new ColumnDefinition$1("state", "", t("general.state"), (dto_3) => (new CellContent(2, [createElement(ProblemReportStateIndicator, {
            State: dto_3.State,
        })])), "none", "text")], (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["timestamp", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            OnRowClick: unwrap(Permissions_has(permissions, new Permission(0, [])) ? (new OnTableRowClick$1(1, [(tool) => RouterModule_encodeParts(ofArray(["tools", tool.ToolId]), 1)])) : undefined),
            RowSelection: "disabled",
            SaveTableConfiguration: false,
        }, {
            ColumnDefinitions: ColumnDefinitions,
            Controls: toList(delay(() => (canReportProblem ? singleton(new TableControl$1(t("dialog.problem_report.btn_title"), Shipment_Warning(), (_arg) => {
                setIsProblemReportOpen(true);
            }, false, false, "set-section-create-problem-report-button")) : empty()))),
            Options: Options,
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }))));
    };
    const children = toList(delay(() => append(isCreateProblemReportOpen ? singleton(createElement(SetCreateProblemReportDialog, {
        IsOpen: isCreateProblemReportOpen,
        OnClose: () => {
            setIsProblemReportOpen(false);
        },
        Set: props.Set,
        SuccessCallback: () => {
            props.Dispatch(new Msg(31, []));
        },
        UserId: props.UserId,
    })) : empty(), delay(() => {
        let elems_1;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(props.ProblemReports) > 5) ? take(5, props.ProblemReports) : props.ProblemReports)), delay(() => {
            let elems;
            return (length(props.ProblemReports) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, {
                CloseButtonTestId: "",
                Content: table(props.ProblemReports),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: t("tool.reported_problems"),
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    }))));
    return reactElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    });
}

function SetDetailsArea(props) {
    let elems_3, elems_1, elems, elems_2;
    const permissions = usePermissions();
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-shrink-0", "flex-col", "mb-3", "bg-white", "rounded", "px-12", "py-9"])], (elems_3 = [createElement(SetDetailsActions, {
        AccountSettings: props.AccountSettings,
        CustomerConfiguration: props.CustomerConfiguration,
        Dispatch: props.Dispatch,
        HasManualHooks: props.HasManualHooks,
        Set: props.Set,
        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
        Storages: props.Storages,
        UserData: props.UserData,
        UserId: props.UserData.UserId,
    }), createElement(NotificationArea, {
        IsCurrentUserStorageResponsible: Permissions_allowsBooking(permissions, new Permission(7, []), props.UserData.UserId, props.Set.LocationInformation.AssignedStorageUserIds, false),
        NotificationToolType: new NotificationToolType_1(2, []),
        Notifications: props.Notifications,
        OnUpdate: () => {
            props.Dispatch(new Msg(32, []));
        },
        UserData: props.UserData,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-x-16", "gap-y-6", "mb-8"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["max-w-full"])], (elems = [createElement(MultipleImageWidget, {
        CanEditImage: props.Set.AccessInformation.IsUserResponsible,
        ComponentState: props.ImagesFormState.IsLoading ? "disabled" : "enabled",
        FormImages: props.SetImages,
        Images: map((image) => ({
            ImageUrl: image.ImageUrl,
            Position: image.Position,
        }), props.Set.SetImages),
        OnImagesChanged: (images) => {
            props.Dispatch(new Msg(9, [images]));
        },
        OnSave: () => {
            props.Dispatch(new Msg(10, []));
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(SetShortDetails, {
        AccountSettings: props.AccountSettings,
        CurrentUser: props.CurrentUser,
        CustomerConfiguration: props.CustomerConfiguration,
        Dispatch: props.Dispatch,
        QuickOverviewDialog: props.QuickOverviewDialog,
        Set: props.Set,
        Storages: props.Storages,
        UserConfiguration: props.UserConfiguration,
        UserData: props.UserData,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-3", "gap-5", "mt-3"])], (elems_2 = [createElement(AppointmentBox, {
        Set: props.Set,
        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
    }), createElement(ReservationBox, {
        Set: props.Set,
        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
    }), createElement(NotificationsBox, {
        ProblemReports: props.ProblemReports,
        SetCurrentSelectedLink: props.SetCurrentSelectedLink,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

function NoticeSection(props) {
    let elems;
    const canWriteNotices = Permissions_has(usePermissions(), new Permission(34, []));
    const messages = map((n) => (new Message_1(new NoticeId(parse(n.Id)), n.Description, undefined, n.CreatedAt, n.CreatorInformation.Name, n.CreatorInformation.Id, n.IsVisibleForUser)), props.Set.Notices);
    const patternInput = reactApi.useState(true);
    const setIsVisibleForUser = patternInput[1];
    const isVisibleForUser = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setSelectedNoticeIdToDelete = patternInput_1[1];
    const selectedNoticeIdToDelete = patternInput_1[0];
    return reactElement("div", createObj(singleton_1((elems = toList(delay(() => {
        let matchValue;
        return append((matchValue = selectedNoticeIdToDelete, (matchValue == null) ? (empty()) : singleton(createElement(OpenNoticeDeleteDialog, {
            IsOpen: selectedNoticeIdToDelete != null,
            NoticeId: matchValue,
            OnClose: () => {
                setSelectedNoticeIdToDelete(undefined);
            },
            SetId: new SetId_2(parse(props.Set.Id)),
            SuccessCallback: () => {
                props.Dispatch(new Msg(32, []));
            },
        }))), delay(() => singleton(createElement(ChatWidget, {
            CanUploadImage: false,
            CanWrite: canWriteNotices,
            CustomerConfiguration: props.CustomerConfiguration,
            FormState: props.FormState,
            MaxContentHeigth: "max-h-96",
            Messages: messages,
            OnDeleteClicked: (message_1) => {
                setSelectedNoticeIdToDelete(message_1.Id);
            },
            OnEditClicked: (message) => {
                props.Dispatch(new Msg(8, [message]));
            },
            OnSubmit: (msg, _arg_2) => {
                props.Dispatch(new Msg(6, [msg, isVisibleForUser]));
                setIsVisibleForUser(true);
            },
            UserData: props.UserData,
            UserId: props.UserId,
            UserVisibility: {
                IsVisibleForUserChecked: isVisibleForUser,
                OnVisibleForUserChecked: setIsVisibleForUser,
            },
        }))));
    })), ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function ToolTable(props) {
    let Title, TableRows, Options;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const stocktakingHistory = useSetStocktakingHistoryIf(props.CanReadStocktakings, props.Set.Id);
    const patternInput_1 = reactApi.useState(empty_1());
    const setSelectedToolIds = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsCreateToolDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const setIsAddToolModalOpen = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setIsRemoveToolIdDialogOpen = patternInput_4[1];
    const xs_1 = [createElement(NewToolModalView, {
        BusinessUnitId: unwrap(props.Set.BusinessUnitId),
        CustomerConfiguration: props.CustomerConfiguration,
        IsOpen: patternInput_2[0],
        IsSelectedStorageIdNeeded: true,
        OnClose: () => {
            setIsCreateToolDialogOpen(false);
        },
        OnSuccessCallback: (toolId) => {
            setIsCreateToolDialogOpen(false);
            props.OnAssignToolId(singleton_1(toolId));
            props.FetchTools();
        },
        StorageId: unwrap(map_1((storageId) => (new StorageId_1(parse(storageId))), props.SelectedStorageId)),
        UserData: props.UserData,
    }), createElement(SelectToolModal, {
        AssignedReceiverId: unwrap(props.Set.LocationInformation.AssignedReceiverId),
        AssignedReceiverName: props.Set.LocationInformation.AssignedReceiverName,
        IsOpen: patternInput_3[0],
        OnAddToolIds: (toolIds) => {
            props.OnAssignToolId(toolIds);
            setIsAddToolModalOpen(false);
        },
        OnClose: () => {
            setIsAddToolModalOpen(false);
        },
        SelectedStorageId: unwrap(props.SelectedStorageId),
        Tools: filter((tool) => !contains(tool.ToolId, map((tool_1) => tool_1.ToolId, props.AssignedTools), {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        }), props.Tools),
    }), createElement(ConfirmationDialog, (Title = t("set.tool_remove_dialog.title"), {
        Description: t("set.tool_remove_dialog.description"),
        IsOpen: patternInput_4[0],
        OnClose: () => {
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty_1());
        },
        OnConfirm: () => {
            props.OnRemoveToolId(patternInput_1[0]);
            setIsRemoveToolIdDialogOpen(false);
            setSelectedToolIds(empty_1());
        },
        Title: Title,
    })), createElement(Table, (TableRows = toArray_1(props.AssignedTools), (Options = {
        BorderStyle: "row",
        CSVDownload: false,
        ConfigurableColumns: false,
        CustomTableFilters: false,
        DefaultSortColumn: ["name", "asc"],
        Fullscreen: false,
        GlobalSearch: false,
        OnRowClick: new OnTableRowClick$1(1, [(tool_2) => RouterModule_encodeParts(ofArray(["tools", tool_2.ToolId]), 1)]),
        RowSelection: "multiRow",
        SaveTableConfiguration: false,
    }, {
        ColumnDefinitions: toArray_2(delay(() => append(singleton(new ColumnDefinition$1("image", t("general.master_data"), t("general.image"), (dto) => (new CellContent(6, [dto.ImageUrl])), "none", "image")), delay(() => append(singleton(new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.DisplayName])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("state", "", t("general.state"), (row_1) => (new CellContent(0, [t(ToolState__ToI18nString(row_1.State))])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (row_2) => (new CellContent(0, [row_2.InventoryNumber])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("manufacturer", "", t("tool.manufacturer"), (row_3) => (new CellContent(0, [row_3.Manufacturer])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("model", "", t("tool.model"), (row_4) => (new CellContent(0, [row_4.Model])), "text", "text")), delay(() => append(singleton(new ColumnDefinition$1("serialNumber", "", t("tool.serial_number"), (row_5) => (new CellContent(0, [row_5.SerialNumber])), "text", "text")), delay(() => append((props.AccountSettings.InspectionsEnabled && isFeatureEnabled(new Feature(21, []))) ? singleton(new ColumnDefinition$1("inspectionStatus", "", t("toolbox.inspection_status"), (row_6) => {
            const status = row_6.InspectionStatus;
            return (status == null) ? (new CellContent(0, [""])) : ((status.tag === 1) ? (new CellContent(4, [singleton_1(new Label_12(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_expired"), "#fd7e14", true, undefined))])) : ((status.tag === 2) ? (new CellContent(4, [singleton_1(new Label_12(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_failed"), "#dc3545", true, undefined))])) : ((status.tag === 3) ? (new CellContent(4, [singleton_1(new Label_12(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_never_inspected"), "#dc3545", true, undefined))])) : (new CellContent(4, [singleton_1(new Label_12(new LabelId("00000000-0000-0000-0000-000000000000"), t("toolbox.inspection_status_ok"), "#28a745", true, undefined))])))));
        }, "select", "text")) : empty(), delay(() => {
            const matchValue = stocktakingHistory;
            if (matchValue == null) {
                return empty();
            }
            else {
                const history = matchValue;
                return singleton(new ColumnDefinition$1("lastStocktaking", "", t("stocktaking.history.last_stocktaking"), (row_7) => setToolLastStocktakingCell(t, (arg, arg_1) => (patternInput[1].t(arg, arg_1)), history.ToolStocktakings, row_7.ToolId), "text", "text"));
            }
        })))))))))))))))))),
        Controls: props.Set.AccessInformation.IsUserResponsible ? toList(delay(() => append(singleton(new TableControl$1(t("general.add"), Shipment_Add(), (_arg_4) => {
            setIsAddToolModalOpen(true);
        }, false, false, "add-tool")), delay(() => append((props.Set.LocationInformation.AssignedReceiverId == null) ? singleton(new TableControl$1(t("tool.create_new_tool"), Shipment_Add(), (_arg_5) => {
            setIsCreateToolDialogOpen(true);
        }, false, false, "create-tool-tool-table")) : empty(), delay(() => singleton(new TableControl$1(t("general.remove"), Recycle_Bin_1(), (tools) => {
            setSelectedToolIds(map((tool_3) => tool_3.ToolId, tools));
            setIsRemoveToolIdDialogOpen(true);
        }, true, false, "set-detail-remove-tool")))))))) : empty_1(),
        Options: Options,
        TableKey: "not-defined-table",
        TableRows: TableRows,
    })))];
    return react.createElement(react.Fragment, {}, ...xs_1);
}

function SetDetail(props) {
    let elems_16, elems_15, elems, Title, SubTitle, cats, elems_1, elems_14;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const allowsInStorage = (permission) => Permissions_allowsInStorage(permissions, permission, props.UserData.UserId, props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds);
    const canReadProblemReports = Permissions_has(permissions, new Permission(38, []));
    const canReadHistory = allowsInStorage(new Permission(32, []));
    const canReadStocktakings = canReadStocktakingHistory(permissions, props.AccountSettings);
    const showTrackers = isAvailable(props.AccountSettings) && canSeeTelematics(permissions);
    const currentState = resolve(useDefinitions(), props.Set.StateKey, ofSetState(props.Set.State));
    const showTrackerMap = showTrackers && isVisible(useAssignedTrackersIf(showTrackers, new TrackerEntityType(1, []), props.Set.Id));
    const canReadReminders = Permissions_allowsObject(permissions, new Permission(18, []), props.UserData.UserId, new StorageAccess(props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds), props.Set.LocationInformation.AssignedReceiverId);
    const patternInput_1 = reactApi.useState("overview-section-id");
    const setCurrentSelectedLink = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_2[1];
    const printLabel = new PrintLabelOptions(new LabelInventoryKind(1, []), props.Set.Id, props.CustomerConfiguration, allowsInStorage(new Permission(24, [])), allowsInStorage(new Permission(22, [])), () => {
        props.Dispatch(new Msg(32, []));
    });
    const children = reactElement("div", createObj(ofArray([["className", "flex grow flex-col"], (elems_16 = [createElement(DeleteDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SetId: new SetId_2(parse(props.Set.Id)),
        SuccessCallback: () => {
            props.Dispatch(new Msg(36, []));
        },
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,minmax(0,80rem)]", "print:flex", "print:flex-col"])], (elems_15 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, (Title = ((props.Set.MasterData.Name !== "") ? props.Set.MasterData.Name : concat(props.Set.MasterData.Manufacturer, " ", ...props.Set.MasterData.Model)), (SubTitle = ((props.Set.MasterData.Name !== "") ? concat(props.Set.MasterData.Manufacturer, " ", ...props.Set.MasterData.Model) : undefined), {
        Badges: (cats = props.Set.AssignedLabel, map((leaf) => createElement(Badge, {
            Color: leaf.ColorHex,
            Label: join(" > ", ofArray(split(leaf.Name, [" > "], undefined, 0))),
            TestId: concat("category-badge-", ...leaf.Id),
        }), filter((c) => !exists_1((o) => {
            if (o.Name !== c.Name) {
                return o.Name.startsWith(c.Name + " > ");
            }
            else {
                return false;
            }
        }, cats), cats))),
        OnBack: () => {
            RouterModule_nav(singleton_1("tools" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
        },
        OnDelete: unwrap(allowsInStorage(new Permission(3, [])) ? (() => {
            setIsDeleteDialogOpen(true);
        }) : undefined),
        OnDuplicate: unwrap(allowsInStorage(new Permission(1, [])) ? (() => {
            RouterModule_nav(ofArray(["sets", props.Set.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : undefined),
        OnEdit: unwrap((allowsInStorage(new Permission(2, [])) && allows_1(new InventoryAction(11, []), currentState)) ? (() => {
            RouterModule_nav(ofArray(["sets", props.Set.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : undefined),
        SubTitle: unwrap(SubTitle),
        Title: Title,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems_1 = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "overview-section-id",
            Label: t("general.overview"),
        }), delay(() => append(singleton({
            Id: "master-data-section-id",
            Label: t("general.master_data"),
        }), delay(() => append(singleton({
            Id: "tools-section-id",
            Label: t("navbar.tools"),
        }), delay(() => append(showTrackerMap ? singleton({
            Id: "tracker-map-section-id",
            Label: t("telematics.map.title"),
        }) : empty(), delay(() => append(singleton({
            Id: "documents-section-id",
            Label: t("general.documents"),
        }), delay(() => append(canReadReminders ? singleton({
            Id: "appointments-section-id",
            Label: t("general.appointments"),
        }) : empty(), delay(() => append(singleton({
            Id: "reservations-section-id",
            Label: t("navbar.reservation"),
        }), delay(() => append(singleton({
            Id: "notices-section-id",
            Label: t("notice.notices"),
        }), delay(() => append(canReadProblemReports ? singleton({
            Id: "problem-report-section-id",
            Label: t("tool.reported_problems"),
        }) : empty(), delay(() => append(singleton({
            Id: "barcodes-section-id",
            Label: isFeatureEnabled(new Feature(18, [])) ? t("general.qr_codes_and_nfc_tags") : t("general.qr_code"),
        }), delay(() => append(canReadStocktakings ? singleton({
            Id: "stocktakings-section-id",
            Label: t("stocktaking.history.title"),
        }) : empty(), delay(() => (canReadHistory ? singleton({
            Id: "history-section-id",
            Label: t("general.history"),
        }) : empty()))))))))))))))))))))))))),
        OnSelectAnchor: setCurrentSelectedLink,
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(singleton_1((elems_14 = toList(delay(() => {
        let elems_2;
        return append(singleton(reactElement("section", createObj(ofArray([["id", "overview-section-id"], (elems_2 = [createElement(SetDetailsArea, {
            AccountSettings: props.AccountSettings,
            CurrentUser: props.CurrentUser,
            CustomerConfiguration: props.CustomerConfiguration,
            Dispatch: props.Dispatch,
            HasManualHooks: props.HasManualHooks,
            ImagesFormState: props.ImagesFormState,
            Notifications: props.Notifications,
            ProblemReports: props.ProblemReports,
            QuickOverviewDialog: props.QuickOverviewDialog,
            Set: props.Set,
            SetCurrentSelectedLink: setCurrentSelectedLink,
            SetImages: props.SetImages,
            Storages: props.Storages,
            UserConfiguration: props.UserConfiguration,
            UserData: props.UserData,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, Title_1;
            return append(singleton(reactElement("section", createObj(ofArray([["id", "master-data-section-id"], (elems_3 = [createElement(SectionContainer, (Title_1 = t("general.master_data"), {
                Content: createElement(MasterDataSection, {
                    AccountSettings: props.AccountSettings,
                    Currency: props.CustomerConfiguration.Currency,
                    Customer: props.UserData.Customer,
                    Set: props.Set,
                }),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_4, Title_2;
                return append(singleton(reactElement("section", createObj(ofArray([["id", "tools-section-id"], (elems_4 = [createElement(TableContainer, (Title_2 = t("navbar.tools"), {
                    Content: createElement(ToolTable, {
                        AccountSettings: props.AccountSettings,
                        AssignedTools: props.Set.AssignedTools,
                        CanReadStocktakings: canReadStocktakings,
                        CustomerConfiguration: props.CustomerConfiguration,
                        FetchTools: () => {
                            props.Dispatch(new Msg(33, []));
                        },
                        OnAssignToolId: (toolIds) => {
                            props.Dispatch(new Msg(15, [toolIds]));
                        },
                        OnRemoveToolId: (toolIds_1) => {
                            props.Dispatch(new Msg(16, [toolIds_1]));
                        },
                        SelectedStorageId: props.Set.LocationInformation.StorageId,
                        Set: props.Set,
                        Tools: props.Tools,
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let elems_5, Title_3;
                    return append(showTrackerMap ? singleton(reactElement("section", createObj(ofArray([["id", "tracker-map-section-id"], (elems_5 = [createElement(TableContainer, (Title_3 = t("telematics.map.title"), {
                        Content: createElement(TrackerMapSection, {
                            EntityId: props.Set.Id,
                            EntityType: new TrackerEntityType(1, []),
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                        let elems_6, Title_4;
                        return append(singleton(reactElement("section", createObj(ofArray([["id", "documents-section-id"], (elems_6 = [createElement(TableContainer, (Title_4 = t("general.documents"), {
                            Content: createElement(DocumentSection, {
                                Dispatch: props.Dispatch,
                                Documents: props.Documents,
                                IsVisibleForUser: props.Set.AccessInformation.IsUserResponsible,
                                SetId: new SetId_2(parse(props.Set.Id)),
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                            let elems_7, Title_5;
                            return append(canReadReminders ? singleton(reactElement("section", createObj(ofArray([["id", "appointments-section-id"], (elems_7 = [createElement(TableContainer, (Title_5 = t("general.appointments"), {
                                Content: createElement(AppointmentsSection, {
                                    Dispatch: props.Dispatch,
                                    Documents: props.Documents,
                                    Set: props.Set,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty(), delay(() => {
                                let elems_8, Title_6;
                                return append(singleton(reactElement("section", createObj(ofArray([["id", "reservations-section-id"], (elems_8 = [createElement(TableContainer, (Title_6 = t("navbar.reservation"), {
                                    Content: createElement(ReservationSection, {
                                        Dispatch: props.Dispatch,
                                        Set: props.Set,
                                        UserData: props.UserData,
                                    }),
                                    Title: unwrap(Title_6),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                    let elems_9, Title_7;
                                    return append(singleton(reactElement("section", createObj(ofArray([["id", "notices-section-id"], (elems_9 = [createElement(SectionContainer, (Title_7 = t("notice.notices"), {
                                        Content: createElement(NoticeSection, {
                                            CustomerConfiguration: props.CustomerConfiguration,
                                            Dispatch: props.Dispatch,
                                            FormState: props.NoticeFormState,
                                            Set: props.Set,
                                            UserData: props.UserData,
                                            UserId: props.UserData.UserId,
                                        }),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => {
                                        let elems_10, Title_8;
                                        return append(canReadProblemReports ? singleton(reactElement("section", createObj(ofArray([["id", "problem-report-section-id"], (elems_10 = [createElement(TableContainer, (Title_8 = t("tool.reported_problems"), {
                                            Content: createElement(ProblemReportSection, {
                                                Dispatch: props.Dispatch,
                                                IsVisibleForUser: props.Set.AccessInformation.IsUserResponsible,
                                                ProblemReports: props.ProblemReports,
                                                Set: props.Set,
                                                UserData: props.UserData,
                                                UserId: props.UserData.UserId,
                                            }),
                                            Title: unwrap(Title_8),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty(), delay(() => {
                                            let elems_11, Title_9, identifiersSection;
                                            return append(singleton(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], (elems_11 = [createElement(TableContainer, (Title_9 = (isFeatureEnabled(new Feature(18, [])) ? t("general.qr_codes_and_nfc_tags") : t("general.qr_code")), {
                                                Content: isFeatureEnabled(new Feature(18, [])) ? ((identifiersSection = ((trackers) => createElement(AssetIdentifiersSection, {
                                                    AssetIdentifiers: append_1(props.Set.AssetIdentifiers, trackers),
                                                    Dispatch: props.Dispatch,
                                                    PrintLabel: printLabel,
                                                    Storage: new StorageAccess(props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds),
                                                    UserData: props.UserData,
                                                })), showTrackers ? createElement(TrackerIdentifiers, {
                                                    EntityId: props.Set.Id,
                                                    EntityType: new TrackerEntityType(1, []),
                                                    Render: identifiersSection,
                                                }) : identifiersSection(empty_1()))) : createElement(BarcodeSection, {
                                                    Dispatch: props.Dispatch,
                                                    PrintLabel: printLabel,
                                                    QRCodeIds: map((_arg_8) => _arg_8.Value, filter((assetIdentifier) => (assetIdentifier.Kind === "qrCode"), props.Set.AssetIdentifiers)),
                                                    Storage: new StorageAccess(props.Set.LocationInformation.StorageId, props.Set.LocationInformation.AssignedStorageUserIds),
                                                    UserData: props.UserData,
                                                }),
                                                Title: unwrap(Title_9),
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                                                let elems_12, Title_10;
                                                return append(canReadStocktakings ? singleton(reactElement("section", createObj(ofArray([["id", "stocktakings-section-id"], (elems_12 = [createElement(TableContainer, (Title_10 = t("stocktaking.history.title"), {
                                                    Content: createElement(SetStocktakingHistorySection, {
                                                        SetId: props.Set.Id,
                                                    }),
                                                    Title: unwrap(Title_10),
                                                }))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))) : empty(), delay(() => {
                                                    let elems_13, Title_11, Title_12, SetName, QrCodeIds, Title_13, matchValue;
                                                    return canReadHistory ? singleton(reactElement("section", createObj(ofArray([["id", "history-section-id"], (elems_13 = [createElement(TableContainerWithTabs, (Title_11 = t("history.title"), {
                                                        Tab1: (Title_12 = t("history.events"), {
                                                            Content: createElement(HistorySection, (SetName = DataTransfer_DetailSet__ReadableDisplayName(props.Set), (QrCodeIds = map((_arg_9) => _arg_9.Value, filter((assetIdentifier_1) => (assetIdentifier_1.Kind === "qrCode"), props.Set.AssetIdentifiers)), {
                                                                BusinessUnitImageUrl: unwrap(props.BusinessUnitImageUrl),
                                                                CustomerConfiguration: props.CustomerConfiguration,
                                                                EntityImageUrl: unwrap(coverImageUrlOption("", props.Set.SetImages)),
                                                                HistoryRows: props.Set.Events,
                                                                InventoryNumber: props.Set.MasterData.InventoryNumber,
                                                                QrCodeIds: QrCodeIds,
                                                                SetName: SetName,
                                                            }))),
                                                            Title: Title_12,
                                                        }),
                                                        Tab2: (Title_13 = t("history.changes"), {
                                                            Content: (matchValue = props.Changelogs, (matchValue.tag === 0) ? createElement(Skeleton, {
                                                                Variant: "table",
                                                            }) : createElement(ChangelogTable, {
                                                                Changelogs: matchValue.fields[0],
                                                            })),
                                                            OnSelect: () => {
                                                                props.Dispatch(new Msg(38, []));
                                                            },
                                                            Title: Title_13,
                                                        }),
                                                        Title: unwrap(Title_11),
                                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))) : empty();
                                                }));
                                            }));
                                        }));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_14))]))))], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])));
    return createElement(HistoryAccessProvider, {
        canReadHistory: canReadHistory,
        children: children,
    });
}

export function SetDetailView(props) {
    let matchValue_11;
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewSet(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.SetId, props.UserData], undefined);
    const state_1 = patternInput[0];
    const patternInput_1 = useTranslation();
    const matchValue = state_1.Set;
    const matchValue_1 = state_1.UserConfiguration;
    const matchValue_2 = state_1.CustomerConfiguration;
    const matchValue_3 = state_1.Storages;
    const matchValue_4 = state_1.Documents;
    const matchValue_5 = state_1.Tools;
    const matchValue_6 = state_1.ProblemReports;
    const matchValue_7 = state_1.Notifications;
    const matchValue_8 = state_1.AccountSettings;
    const matchValue_9 = state_1.BusinessUnitImageUrl;
    let matchResult, accountSettings, businessUnitImageUrl, customerConfiguration, documents, notifications, problemReports, set$, storages, tools, userConfiguration;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_9.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_8.fields[0];
        businessUnitImageUrl = matchValue_9.fields[0];
        customerConfiguration = matchValue_2.fields[0];
        documents = matchValue_4.fields[0];
        notifications = matchValue_7.fields[0];
        problemReports = matchValue_6.fields[0];
        set$ = matchValue.fields[0];
        storages = matchValue_3.fields[0];
        tools = matchValue_5.fields[0];
        userConfiguration = matchValue_1.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(SetDetail, {
                AccountSettings: accountSettings,
                BusinessUnitImageUrl: unwrap(businessUnitImageUrl),
                Changelogs: state_1.Changelogs,
                CurrentUser: props.CurrentUser,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Documents: documents,
                HasManualHooks: (matchValue_11 = state_1.ManualHooks, (matchValue_11.tag === 0) ? false : !isEmpty(matchValue_11.fields[0])),
                ImagesFormState: state_1.ImagesFormState,
                NoticeFormState: state_1.NoticeFormState,
                Notifications: notifications,
                ProblemReports: problemReports,
                QuickOverviewDialog: state_1.QuickOverviewDialog,
                Set: set$,
                SetImages: state_1.SetImages,
                Storages: storages,
                Tools: tools,
                UserConfiguration: userConfiguration,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

